import { ActionList, Button, Popover, Spinner } from '@shopify/polaris'
import { MobileHorizontalDotsMajor } from '@shopify/polaris-icons'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

function ItemMenu({ status, id, testAB, resumeTest, deleteTest, pauseBulkTest, finishBulkTest, resumeTestWithPlanCheck, setShowToast, setMessage }) {

  const [active, setActive] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const dispatch = useDispatch()

  const activator = isDeleting
    ? <div style={{ display: 'flex', alignItems: 'center', padding: '6px 8px' }}><Spinner size="small" /></div>
    : <Button onClick={() => { setActive(true) }} icon={MobileHorizontalDotsMajor} />

  const items = []

  items.push({
    content: 'Delete', onAction: async () => {
      setActive(false)
      setIsDeleting(true)
      await deleteTest(id)
      setIsDeleting(false)
      setShowToast(true)
      setMessage('Deleted')
    }
  })

  if (!testAB.parent_on_bulk) {
    items.push({
      content: 'View Product Page', onAction: async () => {
        window.open(`https://${testAB.shopify_domain}/products/${testAB.test_a.handle}`, '_blank')
      }
    })
  }
  if (status === 'running') {
    items.push({
      content: 'Pause', onAction: async () => {
        if (testAB.parent_on_bulk) {
          await pauseBulkTest(testAB._id)
          setShowToast(true)
          setMessage('Paused')
          setActive(false)
          return
        }
        dispatch({ type: 'SET_TEST_AB', data: testAB })
        dispatch({ type: 'SET_PAUSED_MODAL', data: true })
      }
    })
    items.push({
      content: 'Finish', onAction: async () => {
        if (testAB.parent_on_bulk) {
          await finishBulkTest(testAB._id)
          setShowToast(true)
          setMessage('Finished')
          setActive(false)
          return
        }

        dispatch({ type: 'SET_TEST_AB', data: testAB })
        dispatch({ type: 'SET_WINNER_MODAL', data: true })
      }
    })
  }
  if (status === 'paused') {
    items.push({ content: 'Resume', onAction: async() => {
      await resumeTestWithPlanCheck(testAB._id)
      setShowToast(true)
      setMessage('Resumed')
      setActive(false)
      return
    } })
    items.push({
      content: 'Finish', onAction: async () => {
        if (testAB.parent_on_bulk) {
          await finishBulkTest(testAB._id)
          setShowToast(true)
          setMessage('Finished')
          setActive(false)
          return
        }
        dispatch({ type: 'SET_TEST_AB', data: testAB })
        dispatch({ type: 'SET_WINNER_MODAL', data: true })
      }
    })
  }
  if (status === 'completed' && !testAB.parent_on_bulk) {
    items.push({
      content: 'Choose Winner', onAction: async () => {
        dispatch({ type: 'SET_TEST_AB', data: testAB })
        dispatch({ type: 'SET_WINNER_MODAL', data: true })
        setActive(false)
        return
      }
    })
  }

  return (
    <Popover
      active={active}
      activator={activator}
      preferredAlignment="right"
      onClose={() => {
        setActive(false)
      }}
    >
      <ActionList items={items} />
    </Popover>
  )
}

export default ItemMenu
